<template>
  <div>
    <div class="d-flex align-items-center mb-4">
      <div>
        <h4 class="fw-bold mb-0"><i class="fas fa-cloud-download-alt me-2 text-primary"></i>Import Trade History</h4>
        <p class="text-muted small mb-0 mt-1">
          One-time recovery tool — imports up to 90 days of Alpaca trade history into the local database.
        </p>
      </div>
    </div>
    <AlpacaImportPanel />
  </div>
</template>

<script>
import AlpacaImportPanel from '../components/AlpacaImportPanel.vue';

export default {
  name: 'AlpacaImportView',
  components: { AlpacaImportPanel },
};
</script>
